import { store } from '/store.js'

interface navel {
  page: {
    url: string
    title: string
    blueprint: string
  }
  children: [
    page: {
      url: string
      title: string
      blueprint: string
    }
  ]
}

export const useBreadcrumbs = (targetPath?: string) => {
  const route = useRoute()
  const mainNav = store?.navigations?.main?.tree
  let currentPath = targetPath ?? route.path
  const breadcrumbs: navel[] = []

  if (!mainNav) return breadcrumbs

  // remove the path /plain in the URL of the site "Deutsch - Leichte Sprache"
  // to make sure the condition below where we compare level1.page.url etc. is true
  const splits = currentPath.split('/').filter(v => !!v)
  if (splits[0] === 'plain') {
    currentPath = `/${splits.slice(1).join('/')}`
  }

  mainNav.forEach((level1: navel) => {
    if (level1.page.url == currentPath) breadcrumbs.push(level1)

    level1.children.forEach((level2: navel) => {
      if (level2.page.url == currentPath) breadcrumbs.push(level1, level2)

      level2.children.forEach((level3: navel) => {
        if (level3.page.url == currentPath)
          breadcrumbs.push(level1, level2, level3)
      })
    })
  })

  const result = breadcrumbs
  .filter((crumb) => crumb?.page?.blueprint !== 'section')
  .map((crumb) => {
    return {
      url: crumb?.page?.url,
      title: crumb?.page?.title,
    }
  })

  return result
}
